











































































































































































/* eslint-disable no-unused-vars */
import BaseComponent from '@/components/BaseComponent';
import { Component } from 'vue-property-decorator';
import qs from 'query-string';
import mapStyles from '@/assets/json/gmapstyle.json';
import MarkerClusterer from '@google/markerclustererplus';
// import { MarkerWithLabel } from '@googlemaps/markerwithlabel';
import MarkerWithLabel from '@googlemaps/markerwithlabel';
import { AxiosResponse } from 'axios';
import { batteryDataMdl } from '@/models/batteryDataMdl';
import { userMdl } from '@/models/userMdl';
/* eslint-enable no-unused-vars */
// 旧APIキー
// const apikey = 'AIzaSyCXJkj7AkRDoPylRFLtksopt8lB7fv2kAc';
// テラソルのAPIキー
// const apikey = 'AIzaSyCXJkj7AkRDoPylRFLtksopt8lB7fv2kAc';
// // テラソルのAPIキー
// const apikey = 'AIzaSyByn1PAl4k5MVTaab2nQvrkzWuGDmjMG28';
// キッズウェイのAPIキー;
const apikey = 'AIzaSyATcbySchfeSa9lCQH3HMWIfMZROjivQnE';
const params = {
    v: '3.58',
    key: apikey,
    callback: 'handleLoadGoogleMapsScript',
};

interface GoogleMapWindow extends Window {
    handleLoadGoogleMapsScript: Function;
    google: any;
}

declare const window: GoogleMapWindow;
interface MapStyle {
    [key: string]: any;
}
@Component
export default class GoogleMap extends BaseComponent {
    private google: any = null;
    private map: any = null;
    private geocoder: any = null;
    // マーカー配列
    private marker: any = [];
    private ne_lat: number; // マップの左上の緯度
    private sw_lat: number; // マップの右下の緯度
    private ne_lng: number; // マップの左上の経度
    private sw_lng: number; // マップの右下の経度
    private arrMachineInfo: batteryDataMdl[] = [];

    private icons: { [key: string]: string } = {
        r: require('@/assets/img/marker_red.png'),
        y: require('@/assets/img/marker_yellow.png'),
        g: require('@/assets/img/marker_green.png'),
        e: require('@/assets/img/marker_gray.png'),
    };
    private maxVolt: number = 14.5;
    private openFooter: boolean = false;
    private value: number = 2;
    private valuePercent: number = 60;
    private colors: string[] = ['rgba(21,134,59,1)', 'rgba(209,127,23,1)', 'rgba(185,24,58,1)'];
    private chartColor: string = 'rgba(21,134,59,1)';
    private viewMachineInfo: batteryDataMdl = new batteryDataMdl();
    // MarkerClusterer用配列
    private arrMcs: any = [];
    private markerCluster: any = null;
    // MarkerClustererのオプション
    private mcOptions = { gridSize: 50, maxZoom: 18, imagePath: './img/m' };
    private timer: number = 0; // 定期データ更新用変数
    private UpdateHandler: any = {};
    private selGroupId: number = 0;
    private clickClass: string = '';
    private userData: userMdl;
    private MapStyleObject: MapStyle = mapStyles;
    private selectmapstyle: any = [];
    private selectStyle: string = '';

    // ポリラインの変数
    private placeIdArray: any = [];
    private polylines: any = [];
    private snappedCoordinates: any = [];

    // private visibilitychangeShow: any = {};

    async created() {
        await this.getUserData();
        this.loadGoogleMapsScript().then(google => {
            this.google = google;
            if (!this.map) {
                this.initializeMap();
            }
        });
        this.visibilitychangeShow = this.visibilitychangeShow.bind(this);
        document.addEventListener('visibilitychange', this.visibilitychangeShow);
        this.selectmapstyle = Object.entries(this.MapStyleObject).map(([key]) => ({ value: key, text: key }));
    }

    // GoogleMapAPIの読み込み
    loadGoogleMapsScript() {
        return new Promise((resolve, reject) => {
            if (window.google) {
                return resolve(window.google);
            }
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?${qs.stringify(params)}`;
            // script.async = true; // 非同期でロード
            // script.defer = true; // 実行を遅延させる
            const head = document.querySelector('head');
            if (!head) return reject(new Error('head node is undefined'));
            head.appendChild(script);
            window.handleLoadGoogleMapsScript = () => {
                resolve(window.google);
            };
            setTimeout(() => {
                if (!window.google) {
                    reject(new Error('failed load google api'));
                }
            }, 5000);
        });
    }

    // GoogleMapの初期設定
    async initializeMap() {
        // Loading画面を表示する
        this.$store.dispatch('common/setLoadingStateAc', true);
        await this.getBatteryData(this.selGroupId);

        // 緯度（最大値）
        const latmax: number = Math.max.apply(
            null,
            this.arrMachineInfo.map(function(o: any) {
                return o.latitude;
            })
        );
        // 緯度（最小値）
        const latmin: number = Math.min.apply(
            null,
            this.arrMachineInfo.map(function(o: any) {
                return o.latitude;
            })
        );
        // 経度（最大値）
        const lngmax: number = Math.max.apply(
            null,
            this.arrMachineInfo.map(function(o: any) {
                return o.longitude;
            })
        );
        // 経度（最小値）
        const lngmin: number = Math.min.apply(
            null,
            this.arrMachineInfo.map(function(o: any) {
                return o.longitude;
            })
        );
        const mapContainer: any = this.$el.querySelector('#googleMap');
        const { Map, MapTypeId }: any = this.google.maps;
        const mapGeocoder: any = this.google.maps.Geocoder;
        const mapLatLng: any = this.google.maps.LatLng;
        const mapLatLngBounds: any = this.google.maps.LatLngBounds;
        const mapEvent: any = this.google.maps.event;
        const StyleMapType: any = this.google.maps.StyledMapType;
        const mapInfoWindow: any = this.google.maps.InfoWindow;

        // GoogleMapのインスタンス生成
        this.map = new Map(mapContainer, {
            zoom: 15,
            center: new mapLatLng(35.1844632, 136.9166101),
            mapTypeId: MapTypeId.ROADMAP,
            mapTypeControl: false, // マップコントロールを無効に
            streetViewControl: false, // ストリートビューコントロールを無効に
            scaleControl: true,
            zoomControl: false, // ズームコントロールを無効に
            fullscreenControl: false, // フルスクリーンコントロールを無効に
        });
        // Geocoderのインスタンス生成
        this.geocoder = new mapGeocoder();

        // 地点データの最大と最小を取ってマップ初期表示エリアを最適化
        // 一つもデータが無かったら初期表示
        if (this.arrMachineInfo.length > 0) {
            const latlng_ne: any = new mapLatLng(latmax, lngmax);
            const latlng_sw: any = new mapLatLng(latmin, lngmin);
            const bounds: any = new mapLatLngBounds(latlng_sw, latlng_ne);
            this.map.fitBounds(bounds);
        }

        //イベント登録 地図の表示領域が変更されたらイベントを発生させる
        let outerThis: this = this;
        mapEvent.addListener(this.map, 'idle', function() {
            outerThis.setPointMarker();
        });

        // スタイルの設定

        let mapstyle: string = 'greyscale';
        if (this.userData.map_style != '') {
            mapstyle = this.userData.map_style;
        }
        this.selectStyle = mapstyle;
        let sampleType: any = new StyleMapType(this.MapStyleObject[mapstyle], { name: 'テラソルマップ' });
        this.map.mapTypes.set('sample', sampleType);
        this.map.setMapTypeId('sample');

        // デフォルトの情報ウィンドウを非表示にする
        const set: any = mapInfoWindow.prototype.set;
        mapInfoWindow.prototype.set = function(key: any) {
            if (key === 'map') {
                if (!this.get('noSuppress')) {
                    return;
                }
                set.apply(this, arguments);
            }
        };

        var points = [
            new mapLatLng(35.1958821, 137.0559612),
            new mapLatLng(35.1980821, 137.0559612),
            new mapLatLng(35.1980821, 137.0579612),
            new mapLatLng(35.1958821, 137.0579612),
        ];
        const bermudaTriangle = new this.google.maps.Polygon({
            paths: points,
            strokeColor: '#0ed7e6',
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: '#59fff7',
            fillOpacity: 0.35,
        });

        bermudaTriangle.setMap(this.map);

        // 一つもデータが無かったら初期表示
        if (this.arrMachineInfo.length > 0) {
            this.visibilitychangeShow();
        }
    }

    // ウィンドウのアクティブ状態を取得
    private visibilitychangeShow() {
        // ドキュメントの可視性を表す値を取得する
        // [visible]ページのコンテンツは少なくとも部分的に可視状態
        // [hidden] ページのコンテンツはユーザから見えていない状態
        if (document.visibilityState == 'visible') {
            clearTimeout(this.timer);
            this.timer = setInterval(this.regularUpdate, 60000);
        } else {
            clearTimeout(this.timer);
        }
    }
    // 定期的にデータを更新
    private async regularUpdate() {
        await this.getBatteryData(this.selGroupId);
        this.setPointMarker();
        if (!this.clickClass) return;
        this.clickEventFunc(this.clickClass);
    }

    // バッテリデータを取得
    private async getBatteryData(group_id: number) {
        try {
            let params: any = { group_id: group_id };
            const resp: AxiosResponse<any> = await this.$http.post('battery_data.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    this.arrMachineInfo = resp.data.items.map(function(v: any) {
                        return new batteryDataMdl(batteryDataMdl.toJsonDataOnModel(v));
                    });
                    break;
                case 'DATA_NOTFOUND_ERROR':
                    this.arrMachineInfo = [new batteryDataMdl()];
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            // console.log(error);
            // console.log('ERROR CATCH');
            // this.$store.dispatch('common/setAlertParamsAc', {
            //     is_display: true,
            //     type: 'error',
            //     timeout: 5000,
            //     message: 'データ取得失敗',
            //     return_flg: false,
            // });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // データ取得処理
    private async getUserData() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { user_id: this.$store.getters['user/user_id'] };
            const resp: AxiosResponse<any> = await this.$http.post('user_data.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    this.userData = new userMdl(userMdl.toJsonDataOnModel(resp.data.items[0]));
                    this.selectStyle = this.userData.map_style;
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }

    // Mapの表示（再表示）が終わったら呼ばれる
    private setPointMarker() {
        const StyleMapType: any = this.google.maps.StyledMapType;
        let sampleType: any = new StyleMapType(this.MapStyleObject[this.selectStyle], { name: 'テラソルマップ' });
        this.map.mapTypes.set('sample', sampleType);
        // 機器の情報エリアを非表示
        this.openFooter = false;
        //マーカー削除
        this.MarkerClear();
        //地図の範囲内を取得
        const bounds: any = this.map.getBounds();
        this.ne_lat = bounds.getNorthEast().lat();
        this.sw_lat = bounds.getSouthWest().lat();
        this.ne_lng = bounds.getNorthEast().lng();
        this.sw_lng = bounds.getSouthWest().lng();
        // マーカー毎の処理
        let cnt: number = 0;
        for (var i = 0; i < this.arrMachineInfo.length; i++) {
            if (
                this.arrMachineInfo[i]['latitude'] < this.ne_lat &&
                this.arrMachineInfo[i]['latitude'] > this.sw_lat &&
                this.arrMachineInfo[i]['longitude'] < this.ne_lng &&
                this.arrMachineInfo[i]['longitude'] > this.sw_lng
            ) {
                // 14未満の場合はマーカーサイズ縮小
                let height: number = 47;
                let width: number = 30;
                let labelClass: string = 'googlemarkerlabels';
                if (this.map.getZoom() < 14) {
                    // scaledSize = {scaledSize : new google.maps.Size(19, 25)};
                    // height = 30;
                    // width = 19;
                    height = 30;
                    width = 24;
                    labelClass += ' small';
                    // 14以上の場合はマーカーサイズを戻す
                } else if (this.map.getZoom() >= 14) {
                    // scaledSize = {scaledSize : new google.maps.Size(30, 47)};
                    // height = 47;
                    // width = 30;
                    height = 47;
                    width = 37.7;
                    labelClass = 'googlemarkerlabels';
                }
                labelClass += ' markerid' + this.arrMachineInfo[i]['machine_id'];

                // 緯度経度のデータ作成
                const mapLatLng: any = this.google.maps.LatLng;
                const markerLatLng: any = new mapLatLng({
                    lat: this.arrMachineInfo[i]['latitude'],
                    lng: this.arrMachineInfo[i]['longitude'],
                });
                // const iconurl: string = this.icons[String(this.arrMachineInfo[i]['battery_level'])];
                // 機器のしきい値と通信時間によって色を変える
                let nowtime = new Date();
                let dth = this.arrMachineInfo[i]['acquisition_time'];
                let datatime: Date;
                let diff: number = 0;
                let diffminute: number = 0;
                if (dth) {
                    datatime = new Date(dth.replace(/-/g, '/'));
                    diff = nowtime.getTime() - datatime.getTime();
                    diffminute = diff / (60 * 1000);
                }

                let iconurl: string = '';
                let battery_string: string = '';
                // 30分以上通信が無かったら灰色
                if (diffminute > 60 || !dth) {
                    iconurl = this.icons['e'];
                } else {
                    battery_string = String(this.arrMachineInfo[i]['battery_level']);
                    // バッテリ残量がしきい値より小さかったら赤
                    if (this.arrMachineInfo[i]['battery_level'] < this.arrMachineInfo[i]['threshold_low']) {
                        iconurl = this.icons['r'];
                        // しきい値より大きかったら緑
                    } else if (
                        this.arrMachineInfo[i]['battery_level'] >= this.arrMachineInfo[i]['threshold_low'] &&
                        this.arrMachineInfo[i]['battery_level'] < this.arrMachineInfo[i]['threshold_high']
                    ) {
                        iconurl = this.icons['y'];
                    } else {
                        iconurl = this.icons['g'];
                    }
                }
                // const iconurl: string = this.icons[String(this.arrMachineInfo[i]['battery_level'])];
                const mapMaker: any = this.google.maps.Marker;
                const mapSize: any = this.google.maps.Size;
                // this.marker[cnt] = new mapMaker({
                //     // マーカーの追加
                //     icon: {
                //         url: iconurl,
                //         scaledSize: new mapSize(width, height),
                //     },
                //     position: markerLatLng, // マーカーを立てる位置を指定
                //     map: this.map, // マーカーを立てる地図を指定
                //     id: this.arrMachineInfo[i]['machine_id'],
                // });

                this.marker[cnt] = new MarkerWithLabel({
                    icon: {
                        url: iconurl,
                        scaledSize: new mapSize(width, height),
                    },
                    position: markerLatLng,
                    draggable: false,
                    map: this.map,
                    labelContent: battery_string,
                    labelAnchor: new this.google.maps.Point(22, 0),
                    labelClass: labelClass,
                });

                const outerThis: this = this;
                this.marker[cnt].addListener('click', function(this: any) {
                    // outerThis.clickEventFunc(this.id);
                    outerThis.clickEventFunc(this.labelClass);
                });
                this.arrMcs.push(this.marker[cnt]);
                cnt++;
            }
        }
        // markerclusterを表示
        this.markerCluster = new MarkerClusterer(this.map, this.arrMcs, this.mcOptions);
    }

    // マーカーの削除
    private MarkerClear() {
        if (this.marker.length > 0) {
            for (let i = 0; i < this.marker.length; i++) {
                this.marker[i].setMap(null);
                this.arrMcs.shift();
            }
        }
        // markerclusterを削除
        if (this.markerCluster) {
            this.markerCluster.clearMarkers();
        }
        return;
    }

    // マーカーをクリックした際のイベント
    private clickEventFunc(classes: string) {
        this.clickClass = classes;
        // クラス名から固有IDを抽出
        let arrClass = classes.split(' ');
        let id = '';
        for (let i = 0; i < arrClass.length; ++i) {
            if (arrClass[i].indexOf('markerid') > -1) {
                id = arrClass[i].replace(/markerid/g, '');
            }
        }
        // 機器の情報エリアを表示
        this.openFooter = true;
        const target: any = this.arrMachineInfo.find(m_info => {
            let m: any = m_info;
            return m.machine_id === Number(id);
        });
        this.value = target.battery_level;
        this.valuePercent = Math.round((target.battery_level / this.maxVolt) * 100);
        // if (target.battery_level < 1.5) {
        //     this.chartColor = this.colors[2];
        // } else if (target.battery_level >= 1.5 && target.battery_level < 3) {
        //     this.chartColor = this.colors[1];
        // } else {
        //     this.chartColor = this.colors[0];
        // }
        if (target.battery_level < target.threshold_low) {
            this.chartColor = this.colors[2];
        } else if (target.battery_level >= target.threshold_low && target.battery_level < target.threshold_high) {
            this.chartColor = this.colors[1];
        } else {
            this.chartColor = this.colors[0];
        }
        this.viewMachineInfo = target;
    }

    // Snap a user-created polyline to roads and draw the snapped path
    private async runSnapToRoad(items: any) {
        let arrGeodata: any = [];
        for (let i = 0; i < items.length; ++i) {
            // for (let i = 0; i < 10; ++i) {
            arrGeodata.push(items[i].latitude + ',' + items[i].longitude);
        }
        let paramsGoogle: any = { interpolate: true, key: apikey, path: arrGeodata.join('|') };
        // `https://maps.googleapis.com/maps/api/js?${qs.stringify(params)}`
        const resp: AxiosResponse<any> = await this.$http.get(
            `https://roads.googleapis.com/v1/snapToRoads?${qs.stringify(paramsGoogle)}`
        );
        this.processSnapToRoadResponse(resp.data);
        this.drawSnappedPolyline();
    }
    private processSnapToRoadResponse(data: any) {
        const LatLng: any = this.google.maps.LatLng;
        this.snappedCoordinates = [];
        this.placeIdArray = [];
        for (let i = 0; i < data.snappedPoints.length; i++) {
            var latlng = new LatLng(data.snappedPoints[i].location.latitude, data.snappedPoints[i].location.longitude);
            this.snappedCoordinates.push(latlng);
            this.placeIdArray.push(data.snappedPoints[i].placeId);
        }
    }

    private drawSnappedPolyline() {
        const Polyline: any = this.google.maps.Polyline;
        let snappedPolyline = new Polyline({
            path: this.snappedCoordinates,
            strokeColor: '#ff591c',
            strokeWeight: 6,
            strokeOpacity: 0.9,
        });

        snappedPolyline.setMap(this.map);
        this.polylines.push(snappedPolyline);
    }

    private async getMachineLog() {
        let arrClass = this.clickClass.split(' ');
        let id = '';
        for (let i = 0; i < arrClass.length; ++i) {
            if (arrClass[i].indexOf('markerid') > -1) {
                id = arrClass[i].replace(/markerid/g, '');
            }
        }
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let params: any = { machine_id: id };
            const resp: AxiosResponse<any> = await this.$http.post('machine_log_data.php', params, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                    this.runSnapToRoad(resp.data.items);
                    break;
                case 'DATA_NOTFOUND_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データがありません',
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    // 住所検索
    private moveAddress(searchAddress: string) {
        let outerThis: this = this;

        // Gmapの住所検索
        this.geocoder.geocode({ address: searchAddress }, function(results: any, status: any) {
            if (status == 'OK') {
                outerThis.map.setZoom(15);
                outerThis.map.setCenter(results[0].geometry.location);
            } else {
                // ヒットしなかった場合は機器情報からあいまい検索
                const filterArray = outerThis.arrMachineInfo.filter(val => {
                    return (
                        val.control_number.toString().includes(searchAddress) ||
                        val.lot_number.toString().includes(searchAddress) ||
                        val.machine_name.toString().includes(searchAddress)
                    );
                });
                if (filterArray.length != 0) {
                    var latMin = 90;
                    var latMax = -90;
                    var lngMin = 180;
                    var lngMax = -180;
                    for (var i = 0; i < filterArray.length; i++) {
                        var thisLat = filterArray[i]['latitude'];
                        var thisLng = filterArray[i]['longitude'];
                        latMin = Math.min(latMin, thisLat);
                        latMax = Math.max(latMax, thisLat);
                        lngMin = Math.min(lngMin, thisLng);
                        lngMax = Math.max(lngMax, thisLng);
                    }
                    var min = new outerThis.google.maps.LatLng(latMin, lngMin);
                    var max = new outerThis.google.maps.LatLng(latMax, lngMax);
                    var latLngBounds = new outerThis.google.maps.LatLngBounds(min, max);
                    outerThis.map.fitBounds(latLngBounds);
                    if (filterArray.length == 1) {
                        outerThis.map.setZoom(15);
                    }
                } else {
                    alert('検索結果無し');
                }
            }
        });
    }

    // グループ検索
    private async searchGroup(selectGroup: number) {
        this.selGroupId = selectGroup;
        // 準備が出来てたらイニシャライズ
        if (this.google) {
            this.initializeMap();
        }
    }
    destroyed() {
        clearTimeout(this.timer);
        document.removeEventListener('visibilitychange', this.visibilitychangeShow);
    }
}
